import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import { PdsBox } from '@pine-ds/react';

import PricingOption from './PricingOption';

const PricingOptionSelector = ({ options, formField, onPriceChange }) => {
  const { setValue, watch } = useFormContext();
  const selectedPricingOption = watch(formField);

  useEffect(() => {
    if (!selectedPricingOption && options && options.length > 0) {
      setValue(formField, options[0]);
    }
  }, []);

  const handleOptionChange = (option) => {
    setValue(formField, option);
  };

  return (
    <PdsBox direction="column" gap="sm">
      <h5 className="embedded-checkout-pricing-options-title">Pricing Options</h5>
      {options.map((option) => (
        <PricingOption
          key={option.id}
          option={option}
          isSelected={selectedPricingOption?.id === option.id}
          handleOptionChange={handleOptionChange}
        />
      ))}
    </PdsBox>
  );
};

PricingOptionSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  formField: PropTypes.string.isRequired,
  onPriceChange: PropTypes.func,
};

PricingOptionSelector.defaultProps = {
  onPriceChange: () => {},
};

export default PricingOptionSelector;
